import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "person-panel-list__empty"
}
const _hoisted_2 = { class: "person-panel-list__count" }
const _hoisted_3 = { class: "person-panel-list__count-number" }
const _hoisted_4 = {
  key: 0,
  class: "person-panel-list__divider"
}
const _hoisted_5 = {
  key: 0,
  class: "person-panel-list__load-partial"
}

import {
	computed,
	onMounted,
	onUnmounted,
	ref,
	watch
} from "vue";
import throttle from "lodash/throttle";
import { clientsStore } from "@/store/clients";
import ClientsPanelListItem from "@/components/main/clients-panel/ClientsPanelListItem.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppScrollTopButton from "@/components/ui-kit/button/AppScrollTopButton.vue";
import { useScrollTopButton } from "@/composables/useScrollTopButton";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientsPanelList',
  props: {
    searchText: {}
  },
  emits: ["on-get-partial"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const store = clientsStore()
const $personPanelList = ref<HTMLDivElement | null>(null)

const isLoadingAll = computed(() => store.clientsLoading);
const isLoadingPartial = computed(() => store.clientsPartialLoading);
const clients = computed(() => store.getClients);

const isEmpty = computed(() => !isLoadingAll.value && !clients.value?.length);

const { isScrollTopEnabled, scrollToTop } = useScrollTopButton(
	$personPanelList,
	'[data-contact-id]',
	() => clients.value
)

const onScroll = throttle(() => {
	if (!$personPanelList.value) return

	if ($personPanelList.value.scrollTop + $personPanelList.value.offsetHeight > ($personPanelList.value.scrollHeight - 1000)) {
		if (!isLoadingPartial.value) {
			emit('on-get-partial')
		}
	}
}, 50)

onMounted(() => {
	$personPanelList.value?.addEventListener('scroll', onScroll)
})

onUnmounted(() => {
	$personPanelList.value?.removeEventListener('scroll', onScroll)
	onScroll.cancel()
})

watch(isLoadingAll, (newVal) => {
	if (newVal) {
		$personPanelList.value!.scrollTop = 0
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "person-panel-list",
    ref_key: "$personPanelList",
    ref: $personPanelList
  }, [
    (isLoadingAll.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    (isEmpty.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('contacts_empty')), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t('contacts_found')) + ": ", 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(clients.value?.length || 0), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients.value, (client, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: client.Id
            }, [
              _createVNode(ClientsPanelListItem, {
                client: client,
                "search-text": props.searchText
              }, null, 8, ["client", "search-text"]),
              (index < clients.value.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (isLoadingPartial.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(AppLoader)
              ]))
            : _createCommentVNode("", true)
        ], 64)),
    _createVNode(AppScrollTopButton, {
      enabled: _unref(isScrollTopEnabled),
      onOnClick: _unref(scrollToTop)
    }, null, 8, ["enabled", "onOnClick"])
  ], 512))
}
}

})